<template>
  <LoadingScreen v-cloak="true" />

  <template v-if="isSamsungBrowser">
    <SamsungError />
  </template>

  <div class="pointer-events-none fixed inset-0 z-50 w-screen h-screen overflow-hidden">
    <svg
      class="absolute top-0 left-0 w-full h-full"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <filter id="noise1">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.65"
          numOctaves="1"
          stitchTiles="stitch"
        />
        <feBlend mode="screen" />
      </filter>
      <rect width="100%" height="100%" filter="url(#noise1)" opacity="0.15" />

      <filter id="noise2">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.8"
          numOctaves="1"
          stitchTiles="stitch"
        />
        <feBlend mode="screen" />
      </filter>
      <rect
        width="100%"
        height="100%"
        filter="url(#noise2)"
        opacity="0.12"
      />
    </svg>
  </div>

  <Cursor />
  <Navbar @isLocked="LockeScroll" />

  <main class="relative min-h-full">
    <Hero />
    <div
      class="text-flax-smoke-200 relative rounded-t-3xl bg-[#0B0B0A] py-[5%] overflow-visible"
    >
      <aboutMe />
      <Education />
      <Experience />
      <Skills />
      <Extracurricular />
      <Works />
    </div>

    <Contact />
  </main>

  <Footer />
</template>

<script setup lang="ts">
  import {
    Hero,
    Works,
    aboutMe,
    Experience,
    Education,
    Skills,
    Extracurricular,
    Contact,
  } from '@/components/sections';
  import { onMounted } from 'vue';
  import {
    LoadingScreen,
    SamsungError,
    Footer,
    Cursor,
  } from '@/components/design';

  import { Navbar } from './components/common';
  import { lenis, raf } from './main';

  const isSamsungBrowser = /samsung/i.test(navigator.userAgent);

  const LockeScroll = (isLocked: boolean) => {
    if (isLocked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  // Noise effect is now handled by CSS and SVG attributes

  onMounted(() => {
    document.body.classList.add('stop-scrolling');
    // TODO:
    // window.scrollTo(0, 0);

    setTimeout(() => {
      requestAnimationFrame(raf);
    }, 2000);
  });
</script>

<style>
  .stop-scrolling #app {
    max-height: 100svh !important;
    overflow: hidden !important;
  }

  #app {
    overflow-x: hidden;
    width: 100%;
  }

  main {
    overflow-x: hidden;
    width: 100%;
  }
</style>
